import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["g",{"fill":"#1477FB","clip-path":"url(#rss3-node_svg__a)","key":"svg-g"}],["defs",{"key":"svg-defs"}]]);